import {useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import MenuStage from './components/InitialStage'
import Signin from './components/Signin'
import Signup from './components/Signup'
import {MobileAuthStage} from './core/entities'

const AuthPageMobile = () => {
    const [stage, setStage] = useState<MobileAuthStage>('menu')

    const {stage: stageParam} = useParams()
    const navigate = useNavigate()

    useEffect(() => {
        if (stageParam === 'signin') {
            setStage('signin')
            return
        }
        if (stageParam === 'signup') {
            setStage('signup')
            return
        }
        if (stageParam === '') {
            return
        }

        navigate('/auth')
    }, [navigate, stageParam])

    const onClickStageButtons = (as: MobileAuthStage) => () => {
        setStage(as)
    }

    return (
        <div className="flex min-h-screen w-full overflow-x-hidden bg-white">
            {stage === 'menu' && (
                <MenuStage onClickStageButtons={onClickStageButtons} />
            )}
            {stage === 'signup' && (
                <Signup onCancel={onClickStageButtons('menu')} />
            )}
            {stage === 'signin' && (
                <Signin onCancel={onClickStageButtons('menu')} />
            )}
        </div>
    )
}

export default AuthPageMobile
